const headerResponsive = document.querySelector('#header');
const headerCartIcon = headerResponsive.querySelector('.header__button > a');
const headerCartIconContent = headerCartIcon.textContent;
const menuPrimary = document.querySelector('#menu-menu-principal');
const burgerToggle = document.querySelector('#burger-toggle');

const isMediaLg = () => {
  if (headerResponsive.querySelector('.header__burger-menu')) return;

  const menuResponsive = menuPrimary.cloneNode(true);
  menuResponsive.setAttribute('data-open', 'false');
  menuResponsive.classList.add('header__burger-menu');
  menuResponsive.classList.remove('header__menu');
  headerResponsive.appendChild(menuResponsive);

  headerCartIcon.textContent = '';
};

const isNormal = () => {
  headerCartIcon.textContent = headerCartIconContent;

  headerResponsive.querySelector('.header__burger-menu')?.remove();
  burgerToggle.setAttribute('aria-expanded', 'false');
};

burgerToggle.addEventListener('click', () => {
  const isOpen = burgerToggle.getAttribute('aria-expanded') === 'true';
  const menuResponsive = headerResponsive.querySelector('.header__burger-menu');

  if (isOpen) {
    burgerToggle.setAttribute('aria-expanded', 'false');
    menuResponsive.setAttribute('data-open', 'false');
  } else {
    burgerToggle.setAttribute('aria-expanded', 'true');
    menuResponsive.setAttribute('data-open', 'true');
  }
});

window.addEventListener('resize', () => {
  window.matchMedia('(max-width: 992px)').matches ? isMediaLg() : isNormal();
});

window.matchMedia('(max-width: 992px)').matches ? isMediaLg() : isNormal();
